import { Schema } from "effect";

// Helper to check if something is a Date-like object (handles cross-realm Date objects)
// The pg driver can return Date objects from different JS realms that fail instanceof checks
const isDateLike = (value: unknown): value is Date =>
  Object.prototype.toString.call(value) === "[object Date]";

/**
 * Schema that handles Date objects from the pg driver which may be from different JS realms.
 * Use this instead of Schema.DateFromSelf when reading dates from the database.
 */
export const DateFromDb = Schema.declare(isDateLike, {
  identifier: "DateFromDb",
  description: "Date object from database (handles cross-realm Date objects)",
});

// Helper to check if something is null or a Date-like object
const isNullOrDateLike = (value: unknown): value is Date | null =>
  value === null || isDateLike(value);

/**
 * Schema for nullable Date columns from the database.
 */
export const NullableDateFromDb = Schema.declare(isNullOrDateLike, {
  identifier: "NullableDateFromDb",
  description: "Nullable Date object from database",
});

// Helper to check if something is a Buffer-like object
const isBufferLike = (value: unknown): value is Buffer =>
  Buffer.isBuffer(value) ||
  (value instanceof Uint8Array &&
    Object.prototype.toString.call(value) === "[object Uint8Array]");

/**
 * Schema for BYTES columns in CockroachDB that store MongoDB ObjectIds as binary.
 * The pg driver returns these as Buffer objects.
 */
export const BufferFromDb = Schema.declare(isBufferLike, {
  identifier: "BufferFromDb",
  description:
    "Buffer from database (for BYTES columns storing MongoDB ObjectIds)",
});
